export type ContentFormat = "article" | "book" | "audiobook" | "podcast";

const FORMAT_LABEL: Record<ContentFormat, string> = {
  article: "Artikel",
  book: "Bog",
  audiobook: "Lydbog",
  podcast: "Podcast",
};

export function detectFormat(url: string, title: string): ContentFormat {
  const u = url.toLowerCase();
  const t = title.toLowerCase();

  // Podcasts
  if (
    u.includes("dr.dk/lyd") ||
    u.includes("podcasts.apple.com") ||
    u.includes("open.spotify.com/episode") ||
    u.includes("podbean.com") ||
    u.includes("libsyn.com") ||
    u.includes("soundcloud.com") ||
    u.includes("radio24syv.dk") ||
    t.includes("podcast") ||
    (/\bafsnit\b/.test(t) && (u.includes("dr.dk") || u.includes("radio")))
  ) {
    return "podcast";
  }

  // Lydbøger
  if (
    u.includes("storytel.com") ||
    u.includes("mofibo.com") ||
    u.includes("audible.com") ||
    u.includes("audible.dk") ||
    u.includes("saxo.com/lydbog") ||
    u.includes("saxo.com/lydboeger") ||
    t.includes("lydbog") ||
    t.includes("lydboog")
  ) {
    return "audiobook";
  }

  // Bøger (konservativ – kun klare boghandel-/forlagssignaler)
  if (
    (u.includes("saxo.com") && !u.includes("lydbog")) ||
    u.includes("boghallen.dk") ||
    u.includes("politikensforlag.dk") ||
    u.includes("gyldendal.dk") ||
    u.includes("lindhardtogringhof.dk") ||
    u.includes("peoplespress.dk") ||
    u.includes("williamdam.dk") ||
    u.includes("bogportalen.dk") ||
    u.includes("arnoldbusck.dk") ||
    u.includes("plusbog.dk") ||
    u.includes("bog-ide.dk") ||
    u.includes("bibliotek.dk") ||
    u.includes("openbooks.kb.dk") ||
    u.includes("openlibrary.org") ||
    u.includes("goodreads.com") ||
    u.includes("books.google") ||
    u.includes("/catalog/") ||
    u.includes("forlag") ||
    t.includes("roman") ||
    t.includes("digtsamling")
  ) {
    return "book";
  }


  return "article";
}

export function formatLabel(f: ContentFormat): string {
  return FORMAT_LABEL[f];
}
